'use client'

import SpeedTest from '@/components/SpeedTest/SpeedTest'
import { useModalStore } from '@/stores/useModalStore'
import { useSearchParams } from 'next/navigation'
import { useEffect } from 'react'

export default function SpeedTestUrlHandler () {
  const searchParams = useSearchParams()
  const openModal = useModalStore((state) => state.openModal)

  useEffect(() => {
    if (searchParams.get('speedtest') !== '1') return

    openModal({ content: <SpeedTest /> })

    const params = new URLSearchParams(searchParams.toString())
    params.delete('speedtest')
    const query = params.toString()
    window.history.replaceState({}, '', `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`)
  }, [openModal, searchParams])

  return null
}